import Header from "./Header";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import Hero from "./Hero";
import ChatBot from "./ChatBot/ChatBot";

const Layout = ({ children }: { children: JSX.Element }) => {
  const url = useLocation();

  if (url.pathname.includes("/modo/")) {
    return (
      <div className="flex flex-col h-full bg-white">
        <div className="flex-grow mb-24 mt-16">{children}</div>
      </div>
    );
  }

  if (
    url.pathname == "/alquiler/carga" ||
    url.pathname == "/alquiler/carga/pasos" ||
    url.pathname == "/excursion/carga" ||
    url.pathname == "/excursion/carga/pasos"
  ) {
    return (
      <div className="flex justify-center items-center h-full bg-white min-h-screen font-sans">
        {children}
      </div>
    );
  }

  if (url.pathname == "/reservar") {
    return (
      <div className="flex flex-col h-full font-sans">
        <div className="flex-grow mb-24 mt-16">{children}</div>
      </div>
    );
  }

  if (url.pathname.includes("/alquiler/carga/pasos")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-16">
          {/*  <> {status === "no-authenticated" ? <Login /> : <></>} </> */}
          {children}
        </div>
      </div>
    );
  }

  if (url.pathname.includes("/alquiler/editar/")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-16">
          {/*  <> {status === "no-authenticated" ? <Login /> : <></>} </> */}
          {children}
        </div>
      </div>
    );
  }

  if (url.pathname.includes("/recuperar-contraseña")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-16">
          {children}
        </div>
      </div>
    );
  }

  if (url.pathname.includes("/login")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-16">
          {children}
        </div>
      </div>
    );
  }

  if (url.pathname.includes("/excursion/")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-16">
          {children}
        </div>
      </div>
    );
  }

  if (url.pathname.includes("/alojamiento/")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-16">
          {children}
        </div>
      </div>
    );
  }


  if (url.pathname.includes("/alojamientos")) {
    return (
      <>
        <Header />
        <div className="flex flex-col min-h-screen bg-white font-sans">
          <div className="flex-grow mb-24 mt-1">
            {children}
          </div>
          </div>
        <Footer />
      </>
    );
  }

  if (url.pathname.includes("/excursiones")) {
    return (
      <div className="flex flex-col h-full bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-1">
          {/*  <> {status === "no-authenticated" ? <Login /> : <></>} </> */}
          {children}
        </div>
        <Footer />
      </div>
    );
  }

  if (url.pathname.includes("/mis-reservas")) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-grow mb-24 mt-1">
          {/*  <> {status === "no-authenticated" ? <Login /> : <></>} </> */}
          {children}
        </div>
        <Footer />
      </div>
    );
  }

  if (url.pathname.includes("/chat")) {
    return (
      <div className="flex flex-col min-h-screen bg-white font-sans">
        <Header />
        <div className="flex-grow mb-24 mt-1">
          {/*  <> {status === "no-authenticated" ? <Login /> : <></>} </> */}
          {children}
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="flex flex-col min-h-screen bg-white font-sans">
        <Hero />
        <div className="flex-grow mb-24 mt-2">
          {children}
        </div>
      </div>
      <Footer />
      <ChatBot />
    </>

  );
};

export default Layout;
